import { render, staticRenderFns } from "./ReportTemplate.vue?vue&type=template&id=6518664c&scoped=true&"
import script from "./ReportTemplate.vue?vue&type=script&lang=js&"
export * from "./ReportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReportTemplate.vue?vue&type=style&index=0&id=6518664c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518664c",
  null
  
)

export default component.exports